import { getLang } from "../../utils/functions";

// Define services we use with Wistia
export const services = {
  getVideo: (url) => ({
    route: url,
    method: "get",
    headers: {
      "Data-type": "script",
      "Content-Type": "text/javascript",
      Accept:
        "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript, */*; q=0.01",
    },
  }),
  setProgress: (data) => ({
    data: {
      query: `mutation { saveVideoItemUserProgression(videoItemId: ${data.videoItemId}, progress:${data.progress}, eventType: "${data.eventType}", platform: "web"){
          videoItemUserProgression{
            id
            errors
            { messages }
          }
          errors
        }
      } `,
    },
  }),
  getProgress: (videoItemId) => ({
    data: {
      query: `{ videoItems(id: [${videoItemId}]){ edges { node { id videoItemUserProgression { id progress percentProgress } } } } } `,
    },
  }),
  updateAudioSettings: (language) => ({
    route: "/xhr/users/audio_settings",
    method: "patch",
    data: {
      language,
    },
  }),
};
